// src/pages/Achieve.jsx
import React, { useMemo, useRef, useState } from 'react';
import './Achieve.css';
import AchieveDetail from './views/AchieveDetail';

export default function Achieve() {
    const [selected, setSelected] = useState(null);

    // ---- Data (demo) ----
    const highlight = {
        title: 'Modern iOS Programming Course',
        org: 'MultiGroup Community',
        deadline: 'Son teslim Tarihi : 20 Haziran',
        progress: 80,
        cover: 'https://picsum.photos/seed/ios/420/260'
    };

    const makeCard = (i) => ({
        id: i,
        title: 'Modern iOS Programming',
        subtitle: 'Course - Katılım Sertifikası',
        org: 'MultiGroup Community',
        cover: `https://picsum.photos/seed/ios-${i}/480/320`,
        tags: ['Yazılım', 'Mobil', 'iOS', 'Bootcamp'],
        desc:
            'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text...',
        lastDate: '12 Haziran'
    });

    const upcoming = useMemo(() => Array.from({ length: 10 }, (_, i) => makeCard(i + 1)), []);
    const past = useMemo(() => Array.from({ length: 12 }, (_, i) => makeCard(i + 20)), []);
    const certs = useMemo(() => Array.from({ length: 12 }, (_, i) => ({ id: i + 100 })), []);

    // ---- Carousel helpers ----
    const rowRefs = {
        upcoming: useRef(null),
        past: useRef(null),
        orgs: useRef(null),
        programs: useRef(null),
    };

    const scrollByAmount = (ref, px) => {
        if (!ref?.current) return;
        ref.current.scrollBy({ left: px, behavior: 'smooth' });
    };

    // ---- Detail view ----
    if (selected) {
        return (
            <div className="ach ach--detail">
                <div className="ach-detail-topbar">
                    <button className="btn-ghost" onClick={() => setSelected(null)}>← Geri</button>
                    <div />
                </div>
                <AchieveDetail item={selected} onClose={() => setSelected(null)} />
            </div>
        );
    }

    else {
        // ---- List view ----
        return (
            <div className="ach">
                {/* HERO */}
                <section className="ach-hero card">
                    <div className="ach-hero-left">
                        <h1 className="ach-hero-kicker">Achieve</h1>
                        <h2 className="ach-hero-title">Your Potential.</h2>
                        <p className="ach-hero-desc">
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
                            standard dummy text ever since the 1500s, when an unknown printer
                        </p>
                        <div className="ach-hero-actions">
                            <button className="btn-primary">Programları Keşfet</button>
                            <button className="btn-ghost">Sertifikalarım</button>
                        </div>
                    </div>
                    <div className="ach-hero-right">
                        <div className="ach-hero-logo">
                            <div className="ach-hero-b1" />
                            <div className="ach-hero-b2" />
                            <div className="ach-hero-b3" />
                            <div className="ach-hero-b4" />
                        </div>
                    </div>
                </section>

                {/* ÖNE ÇIKAN */}
                <section className="ach-highlight card">
                    <div className="hl-left">
                        <img src={highlight.cover} alt={highlight.title} />
                    </div>
                    <div className="hl-right">
                        <div className="hl-top">
                            <span className="hl-deadline">{highlight.deadline}</span>
                            <h3 className="hl-title">{highlight.title}</h3>
                            <div className="hl-org">
                                <span className="hl-org-dot" />
                                {highlight.org}
                            </div>
                        </div>
                        <div className="hl-progress">
                            <div className="hl-progress-bar">
                                <span style={{ width: `${highlight.progress}%` }} />
                            </div>
                            <div className="hl-progress-text">%{highlight.progress} Tamamlandı</div>
                        </div>
                    </div>
                </section>

                {/* YAKLAŞAN PROGRAMLAR (daha geniş, dikdörtgenimsi kartlar) */}
                <section className="ach-section">
                    <div className="ach-section-head">
                        <div className="ach-section-title">Yaklaşan Programlar</div>
                        <div className="ach-arrows">
                            <button className="ach-arrow" aria-label="previous"
                                onClick={() => scrollByAmount(rowRefs.upcoming, -520)}>‹</button>
                            <button className="ach-arrow" aria-label="next"
                                onClick={() => scrollByAmount(rowRefs.upcoming, 520)}>›</button>
                        </div>
                    </div>

                    <div className="ach-row">
                        <div className="ach-fade-left" />
                        <div className="ach-fade-right" />
                        <div ref={rowRefs.upcoming} className="ach-track ach-track--wide">
                            {upcoming.map((c) => (
                                <article key={c.id} className="ach-card ach-card--up" onClick={() => setSelected(c)}>
                                    <img className="ach-card-cover" src={c.cover} alt={c.title} />
                                    <div className="ach-card-body">
                                        <div className="ach-card-head">
                                            <h4 className="ach-card-title">{c.title}</h4>
                                            <div className="ach-card-sub">{c.subtitle}</div>
                                        </div>
                                        <p className="ach-card-desc">{c.desc}</p>
                                        <div className="ach-card-meta">
                                            <span className="ach-card-meta-label">Son başvuru:</span>
                                            <span className="ach-card-meta-value">{c.lastDate}</span>
                                        </div>
                                        <div className="ach-card-tags">
                                            {c.tags.map((t, i) => (
                                                <span key={i} className="ach-tag">{t}</span>
                                            ))}
                                        </div>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                {/* GEÇMİŞ PROGRAMLAR (daha karemsi, kompakt kartlar) */}
                <section className="ach-section">
                    <div className="ach-section-head">
                        <div className="ach-section-title">Geçmiş Programlar</div>
                        <div className="ach-arrows">
                            <button className="ach-arrow" onClick={() => scrollByAmount(rowRefs.past, -420)}>‹</button>
                            <button className="ach-arrow" onClick={() => scrollByAmount(rowRefs.past, 420)}>›</button>
                        </div>
                    </div>

                    <div className="ach-row">
                        <div className="ach-fade-left" />
                        <div className="ach-fade-right" />
                        <div ref={rowRefs.past} className="ach-track ach-track--compact">
                            {past.map((c) => (
                                <article key={c.id} className="ach-mini" onClick={() => setSelected(c)}>
                                    <img className="ach-mini-cover" src={c.cover} alt={c.title} />
                                    <div className="ach-mini-body">
                                        <div className="ach-mini-title">{c.title}</div>
                                        <div className="ach-mini-sub">{c.subtitle}</div>
                                    </div>
                                    <div className="ach-mini-actions">
                                        <span className="ach-dot" />
                                        <span className="ach-dot" />
                                        <span className="ach-dot" />
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                {/* SERTİFİKA VEREN KURUMLAR (karemsi badge’ler) */}
                <section className="ach-section">
                    <div className="ach-section-head">
                        <div className="ach-section-title">Sertifika Veren Kurumlar</div>
                        <div className="ach-arrows">
                            <button className="ach-arrow" onClick={() => scrollByAmount(rowRefs.orgs, -360)}>‹</button>
                            <button className="ach-arrow" onClick={() => scrollByAmount(rowRefs.orgs, 360)}>›</button>
                        </div>
                    </div>

                    <div className="ach-row">
                        <div className="ach-fade-left" />
                        <div className="ach-fade-right" />
                        <div ref={rowRefs.orgs} className="ach-track ach-track--badges">
                            {certs.map((x) => (
                                <div key={x.id} className="ach-badge">
                                    <div className="ach-badge-blob" />
                                    <div className="ach-badge-blob" />
                                    <div className="ach-badge-blob" />
                                    <div className="ach-badge-blob" />
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* SERTİFİKA PROGRAMLARI (dikdörtgenimsi – upcoming ile aynı oran) */}
                <section className="ach-section">
                    <div className="ach-section-head">
                        <div className="ach-section-title">Sertifika Programları</div>
                        <div className="ach-arrows">
                            <button className="ach-arrow" onClick={() => scrollByAmount(rowRefs.programs, -520)}>‹</button>
                            <button className="ach-arrow" onClick={() => scrollByAmount(rowRefs.programs, 520)}>›</button>
                        </div>
                    </div>

                    <div className="ach-row">
                        <div className="ach-fade-left" />
                        <div className="ach-fade-right" />
                        <div ref={rowRefs.programs} className="ach-track ach-track--wide">
                            {upcoming.concat(upcoming).map((c) => (
                                <article key={`p-${c.id}`} className="ach-card ach-card--up" onClick={() => setSelected(c)}>
                                    <img className="ach-card-cover" src={c.cover} alt={c.title} />
                                    <div className="ach-card-body">
                                        <div className="ach-card-head">
                                            <h4 className="ach-card-title">{c.title}</h4>
                                            <div className="ach-card-sub">{c.subtitle}</div>
                                        </div>
                                        <div className="ach-card-tags">
                                            {c.tags.map((t, i) => (
                                                <span key={i} className="ach-tag">{t}</span>
                                            ))}
                                        </div>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        );
    }

}